module.exports = __webpack_public_path__ + "img/hairsalon2.bd8cdc37.png";